// src/components/helpers/WarningSummary.js

import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Link from "@mui/material/Link";
import Paper from "@mui/material/Paper";
import Alert from "@mui/material/Alert";

function WarningSummary({ warningSteps, steps, onNavigate }) {
  if (warningSteps.length === 0) return null;

  return (
    <Paper
      elevation={0}
      sx={{
        p: { xs: 2, sm: 3 },
        borderRadius: 2,
        border: "1px solid",
        borderColor: "divider",
        bgcolor: "background.paper",
      }}
      className="form-group"
    >
      <Alert severity="warning" sx={{ mb: 2, fontWeight: 700 }}>
        Please review the following warnings:
      </Alert>
      <List disablePadding>
        {warningSteps.map(({ stepIndex, warnings }) => (
          <ListItem
            key={stepIndex}
            disableGutters
            sx={{ mb: 1, alignItems: "flex-start", flexDirection: "column" }}
          >
            <Typography
              variant="subtitle2"
              component="div"
              color="warning.main"
              sx={{ fontWeight: 600, cursor: "pointer", mb: 0.5 }}
              onClick={() => onNavigate(stepIndex)}
            >
              <Link
                component="button"
                underline="hover"
                sx={{ fontWeight: 600, color: "warning.main" }}
              >
                {steps[stepIndex]?.label}
              </Link>
            </Typography>
            {Object.entries(warnings).map(([type, message]) => (
              <Typography
                key={type}
                variant="body2"
                component="div"
                color="warning.main"
                sx={{ pl: 2, mb: 0.5 }}
              >
                • {message}
              </Typography>
            ))}
          </ListItem>
        ))}
      </List>
    </Paper>
  );
}

export default WarningSummary;
